<template>
  <v-container>
    <v-row class="mt-3" justify="center">
      <v-col cols="12" lg="10" xl="8">
        <!-- Add 3 cards here -->
        <v-row class="mb-6">
          <v-col v-for="card in cards" :key="card.title" cols="12" sm="4">
            <v-card :style="{ height: '100%' }">
              <v-img
                class="primary--text align-end card-image"
                :src="card.image"
              >
                <v-card-title>{{ card.title }}</v-card-title>
              </v-img>
              <v-card-text>{{ card.text }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Render the variable contents -->
        <div
          v-for="(section, index) in websiteVariables.sections"
          :key="index"
          class="section-div"
        >
          <h2 v-if="section.title && section.title.length > 0">
            {{ section.title }}
          </h2>
          <v-card-text v-html="section.text"></v-card-text>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.section-div h2 {
  text-align: center;
  position: relative;
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 26px;
}

.section-div h2::before {
  position: absolute;
  content: "";
  width: 50px;
  left: 50%;
  top: 40px;
  transform: translate(-50%, 0);
  height: 0;
  border-top: 3px solid var(--v-primary-base);
}

.card-image {
  max-height: 200px;
}

@media (max-width: 600px) {
  .card-image {
    max-height: 150px;
  }
}
</style>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    cards: [
      {
        title: "Title 1",
        text:
          "Suspendisse dignissim mi quis leo mattis pretium. Nam fringilla purus eget dui mollis commodo. Maecenas imperdiet elit placerat massa aliquet, eget consequat nunc congue.",
        image:
          "https://lunawood.com/wp-content/uploads/2018/02/placeholder-image.png"
      },
      {
        title: "Title 2",
        text:
          "Suspendisse dignissim mi quis leo mattis pretium. Nam fringilla purus eget dui mollis commodo. Maecenas imperdiet elit placerat massa aliquet, eget consequat nunc congue.",
        image:
          "https://lunawood.com/wp-content/uploads/2018/02/placeholder-image.png"
      },
      {
        title: "Title 3",
        text: "Suspendisse dignissim mi quis leo mattis pretium.",
        image:
          "https://lunawood.com/wp-content/uploads/2018/02/placeholder-image.png"
      }
    ]
  }),
  computed: {
    ...mapState(["websiteVariables"])
  }
};
</script>
